import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_V3_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioHomepageApi = createApi({
  reducerPath: 'audioHomepageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_V3_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioHomepageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudioHomeData: builder.query({
      query: () => ({
        url : 'home/v2',
        method: 'POST',
        body : {
            "phone": "",
            "platform": "telenor",
            "udid": "",
            "user_id": getLocalStorageData(),
            "version_code": 70, // 29
            "version_name": "1.2.9"
        },
      }), 
    })
  }),
});

export const { useFetchAudioHomeDataQuery, endpoints } = audioHomepageApi;